// 迁移任务状态
export const TaskStatusEnum = {
  NEW: 'NEW',
  DOING: 'DOING',
  DONE: 'DONE',
  ERROR: 'ERROR'
};
